@if (viewModel$ | async; as vm) {
  @if (vm.allSalesFunnelsDisabled === true) {
    <wl-info-card
      [title]="vm.allSalesFunnelsDisabledMessageTitle"
      [message]="vm.allSalesFunnelsDisabledMessageText"
      [buttonLink]="vm.allSalesFunnelsDisabledMessageLink"
      type="warning"
    ></wl-info-card>
  } @else {
    <wl-calculate-form
      id="calculate-form"
      [rendering]="rendering"
      [content]="content"
      [formState]="vm.formState"
      [installationAddressStatus]="vm.installationAddressStatus"
      [installationAddressNotFound]="vm.installationAddressNotFound"
      [houseNumberExtensions]="vm.houseNumberExtensions"
      [installationAddresses]="vm.installationAddresses"
      [showManualHouseNumberAdditionInput]="vm.houseNumberAdditionInputEnabled"
      [showSpinnerWhenSubmitButtonDisabled]="
        vm.showSpinnerWhenSubmitButtonDisabled
      "
      [submitButtonDisabled]="vm.isSubmitButtonDisabled"
      [isInModal]="isInModal"
      (submitCalculate)="submit()"
      (openModal)="openModal($event)"
      (hideHouseNumberInput)="hideManualHousenumberInput()"
      (submitAlternateAddress)="submitAlternateAddress()"
    ></wl-calculate-form>
  }
}
